/* Este componente lanza un modal con la traducción de las claves enviadas como cabecera y mensaje, y si se 
accepta realiza la acción enviada.

El componente se debe importar en el componente padre

import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";

y llamarlo desde la función deseada

openModal() {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'xl'
    });
    modal.componentInstance.message = 'MESSAGE';
    modal.componentInstance.header = 'HEADER';
    modal.componentInstance.action = this.answer;
  }

  debe estar importado en el constructor el modalservice (public modalService: NgbModal)

*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit {
  @Input() header: string;
  @Input() message: string;
  @Input() data: any;
  @Output() action: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal) {
  }

  confirm() {
    this.action.emit(this.data);
    this.closeModal();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  ngOnInit() {

  }

}
